<template>
  <div style="padding: 20px">
    <!--条件搜索-->
    <div class="handle-box">
      <el-select  placeholder="学员类型" style="margin-right: 10px" v-model="query.studentType">
              <div>
                <el-option label="全部"></el-option>
                <el-option label="中招体育" value="1"></el-option>
                <el-option label="少年" value="2"></el-option>
                <el-option label="高考体育" value="4"></el-option>
                <el-option label="幼儿" value="5"></el-option>
              </div>
            </el-select>
              <el-select  v-model="query.regionId" placeholder="城市" class="handle-select mr10">
                  <el-option @click="selectCity1(index)"
                             v-for="(item,index) in regionList" :key="index"
                             :label="item.name"
                             :value="item.id"></el-option>
              </el-select>
      <el-input v-model="query.student" clearable placeholder="学生" class="handle-select mr10"></el-input>
      <el-input v-model="query.teacher" clearable placeholder="老师" class="handle-select mr10"></el-input>
      <el-select v-model="query.classType" placeholder="类型" class="handle-select mr10">
        <el-option v-for="(item,index) in typeList" :key="index"
                   :label="item.dictLabel" :value="item.dictValue"></el-option>
      </el-select>
      <el-date-picker style="width: 260px" v-model="v1" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期">
      </el-date-picker>
      <el-button type="primary" icon="Search" style="margin-left: 10px" @click="handleSearch">搜索
      </el-button>
      <el-button type="info" @click="reset">重置</el-button>

      <el-popconfirm @confirm="exportExcel" title="确定要导出吗？">
        <template #reference>
          <el-button v-permission="['trainingRecord:export']" type="primary" icon="Download">导出</el-button>
        </template>
      </el-popconfirm>
    </div>
    <!--table展示数据-->
    <el-table
        height="610px"
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        :row-style="{height:0+'px'}"
        :cell-style="{padding:0+'px'}"
    >
      <el-table-column
          width="155"
          show-overflow-tooltip="true"
          prop="classTime"
          label="上课时间"
      ></el-table-column>
      <el-table-column
          width="100"
          show-overflow-tooltip="true"
          prop="classTypeName"
          label="上课类型">
      </el-table-column>
      <el-table-column
          width="130"
          show-overflow-tooltip="true"
          prop="teacher"
          label="上课老师"
      ></el-table-column>
      <el-table-column
          width="100"
          label="所属城市">
        <template #default="scope">{{ scope.row.regionName != null ? scope.row.regionName : '' }}</template>
      </el-table-column>
      <el-table-column
        width="110"
        align="center"
        label="校区图片">
        <template v-slot="scope">
          <el-image
              class="code"
              :src="scope.row.img != null? JSON.parse(scope.row.img)[0]:null"
              :preview-src-list="scope.row.img != null?JSON.parse(scope.row.img):null">
            <template #error>
              <div class="code">
              </div>
            </template>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
          width="230"
          show-overflow-tooltip="true"
          prop="note"
          label="备注">
      </el-table-column>
      <el-table-column
          width="280"
          show-overflow-tooltip="true"
          prop="student"
          label="学生">
      </el-table-column>
      <el-table-column
          width="100"
          show-overflow-tooltip="true"
          prop="submitName"
          label="提交人">
      </el-table-column>
      <el-table-column
          width="180"
          show-overflow-tooltip="true"
          prop="createTime"
          label="创建时间">
      </el-table-column>
    </el-table>
    <!--分页-->
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import {getTrainingRecord, excel} from "@/api/trainingRecord";
import {selectAreaByExpress} from "@/api/area";
import {selectDictByType} from "@/api/dict";
export default {
  name: "TrainingRecord",
  data() {
    return {
      tableData: [],
      pageTotal: null,
      v1: [],
      regionList: [],
      startDateAndEndDate: null,
      typeList:[],
      query: {
        studentType:'',
        pageIndex: 1,
        pageSize: 10,
        student: '',
        teacher: '',
        classType:'',
        startTime: '',
        endTime: '',
        regionId:''
      },
    }

  },
  methods: {
    selectCity1(val) {
          this.query.regionId = this.regionList[val].id
            },
    getData() {
      getTrainingRecord(this.query).then(val => {
        if (val.code == 200) {
          this.tableData = val.data.records;
          this.pageTotal = val.data.total;
          this.student = val.data.student;
          this.teacher = val.data.teacher;
          this.classType=val.data.classType;
        } else {
          this.$message.error("获取表格数据失败");
        }
        console.log(val)
      })
    },
    /**
     * 切换页面
     */
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getData();
    },
    // 触发搜索按钮
    handleSearch() {
      if (this.v1.length >= 2) {
        this.query.startTime = this.dateFormat(this.v1[0]);
        this.query.endTime = this.dateFormat(this.v1[1]);
      }
      this.query.pageIndex = 1
      this.getData();
    },
    //导出
    exportExcel() {
      this.loading = true
      if (this.startDateAndEndDate) {
        this.query.startDate = this.dateFormat(this.startDateAndEndDate[0])
        this.query.endDate = this.dateFormat(this.startDateAndEndDate[1])
      }
      excel(this.query).then(res => {
        console.log(res)
        this.loading = false
        let blob = new Blob([res], {type: "application/vnd.ms-excel"});
        console.log(blob);
        let objectUrl = URL.createObjectURL(blob);
        console.log(objectUrl);
        const link = document.createElement('a');//我们用模拟q标签点击事件
        const fname = '培训统计表'; //下载文件的名字
        link.href = objectUrl;
        link.setAttribute('download', fname);
        document.body.appendChild(link);
        /**
         * 在这期间，我们可以做自己界面的反应逻辑
         **/
        link.click();//点击
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(URL); // 释放掉blob对象
      })
    },

    // 重置
    reset() {
      this.query.studentType=''
       this.query.regionId=''
      this.query.student = ""
      this.query.teacher = ""
      this.query.classType=""
      // 日期
      this.v1 = []
      this.query.startTime = ""
      this.query.endTime = ""
      this.query.pageIndex = 1
      this.getData()
    },
    dateFormat(val) {
      var date = new Date(val)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      var d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      const time = y + '-' + m + '-' + d
      return time
    }
  },

  /**
   * 加载页面
   */
  created() {
    selectAreaByExpress().then(res => {
            if (res.code == 200) {
              this.regionList = res.data
            } else {
              this.$message.error("获取城市数据失败");
            }
    })
    this.getData();
    selectDictByType("trainingType").then(res => {
      if (res.code == 200) {
        this.typeList = res.data
        console.log(this.typeList)
      } else {
        this.$message.error("获取数据失败");
      }
    })
  },

}

</script>

<style scoped>
.handle-box {
  display: flex;
  margin-bottom: 20px;
}

.handle-select {
  width: 160px;
}

.mr10 {
  margin-right: 10px;
}

.code {
  margin-top: 8px;
  width: 80px;
  height: 40px;
  border-radius: 6px;
  background-color: #efefef;
}

/deep/ .el-upload--picture-card {
  width: 80px;
  height: 80px;
}

/deep/ .el-upload {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

/deep/ .avatar {
  width: 80px;
  height: 80px;
}
</style>
